module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter1"
    }
  }, [_vm._v("1. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFORE THE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter1#ch01-sec1"
    }
  }, [_vm._v("The Kansas-Nebraska Act")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter1#ch01-sec2"
    }
  }, [_vm._v("Bleeding Kansas: Jayhawkers and Border Ruffians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. 1861: T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESUMES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter2#ch02-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Early Moves")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter2#ch02-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jennison’s Raid")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. 1862: G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UERRILLAS")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILL THE")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OID")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter3#ch03-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lieber Code")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter3#ch03-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Military Commissions: “Tribunals of Necessity”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter3#ch03-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quantrill Emerges")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter3#ch03-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joseph C. Porter, Recruiting Behind the Lines and the Palmyra Massacre")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HO")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERE THE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UERRILLAS")]), _vm._v("?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter4#ch04-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Politics, Revenge and Murder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter4#ch04-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William Quantrill")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter4#ch04-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William “Bloody Bill” Anderson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter4#ch04-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George Todd")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter4#ch04-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dave Poole and Charles Fletcher Taylor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter4#ch04-sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cliff Holtzclaw")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter4#ch04-sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Samuel Hildebrand")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter4#ch04-sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frank and Jesse James")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter4#ch04-sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alvin Cobb")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter4#ch04-sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry Taylor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TTACKED BY")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTH")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDES")]), _vm._v("—C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVIL")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFE IN")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URAL")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISSOURI")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter5#ch05-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Civilians as Victims and Supporters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter5#ch05-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slaves")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. 1863–1864: T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTRUCTION OF")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AWRENCE AND")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RDER")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O")]), _vm._v(". 11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter6#ch06-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("General Ewing’s Problem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter6#ch06-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lawrence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter6#ch06-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Order No. 11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter6#ch06-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pursuit of Quantrill and the Baxter Springs Massacre")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter6#ch06-sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aftermath")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. 1864: T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTRALIA")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASSACRE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter7#ch07-sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“There Are Guerrillas There, Sure”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter7#ch07-sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“When I Give the Word, Pour Hell into Them”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter7#ch07-sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Why, the Fools Are Going to Fight Us On Foot”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter7#ch07-sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“The Inhuman Butcher of Centralia Sleeps His Last Sleep”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. 1865: T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDS, BUT THE")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IOLENCE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTINUES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 63
// module chunks = 0